import React from "react";

import * as PreCheck from "./PreCheck";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

import Flag from "react-world-flags";

const Render = (props) => {
  const { portfolio, actions } = props;

  return (
    <div>
      <div style={{ color: "#797878", fontSize: 16 }}>
        <p style={{ fontWeight: "bold", fontSize: 18 }}>
          Required Portfolio Report Information
        </p>
        <p>
          Obtain your portfolio reports for every month end in your analysis
          period; for example, an analysis period from Dec. 31, 2017 to Feb. 28,
          2019 requires 15 reports. You may save time and effort by importing a
          copy of one of your existing analysis. The data will be imported and
          available for editing or adding additional months. This feature is
          located on your <a href="/#/Account">account page</a>.
        </p>
        <p>
          A report must contain the end of month overall portfolio value, the
          amounts and exact dates of any portfolio transfers (contributions and
          withdrawals) you made to your portfolio, and any management fees paid.
        </p>

        <ul>
          <li>
            The reports must convert all values and amounts to a single Home
            Country currency; e.g., US $ (USD) or Canadian $ (CAD).
          </li>
          <li>
            Your manager/broker report typically shows the portfolio value at
            the close of trading on the last trading day of a month. This date
            may not be the calendar month end but is treated as the month end by
            the software.
          </li>
          <li>
            Management Fees are sometimes paid in a lump sum that may be outside
            your specified analysis period. In this case, you should enter a
            monthly equivalent management fee in each month of your analysis
            period.
          </li>
          <li>
            Do not include any transfers on or before the close of the starting
            month, Dec 31, 2017 in the preceding example.
          </li>
          <li>
            Transactions within the portfolio, such as dividends and asset
            sales/purchases are not transfers and are not required.
          </li>
        </ul>
      </div>

      <div
        style={{
          fontWeight: "bold",
          fontSize: 18,
          color: "#797878",
          marginTop: 50,
        }}
      >
        Portfolio’s Home Currency
      </div>
      <div style={{ width: 300 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-outlined-label">
            Select Currency
          </InputLabel>
          <Select
            fullWidth
            value={portfolio.currencyType ? portfolio.currencyType : ""}
            onChange={(e, v) => {
              actions.setPortfolioValue(
                props,
                portfolio.portfolioNumber,
                "currencyType",
                e.target.value
              );

              if (e.target.value === "USD") {
                //clear non US benchmarks
                actions.setBenchmarkValue(
                  props,
                  portfolio.portfolioNumber,
                  "worldDeveloped",
                  0,
                  "clientSpecified"
                );

                actions.setBenchmarkValue(
                  props,
                  portfolio.portfolioNumber,
                  "selected",
                  false,
                  "worldDeveloped"
                );
              }
            }}
            label="Age"
          >
            <MenuItem value={"CAD"}>
              <Flag code={"CAN"} height="16" style={{ marginRight: 10 }} />{" "}
              Canadian Dollars
            </MenuItem>
            <MenuItem value={"USD"}>
              <Flag code={"USA"} height="16" style={{ marginRight: 10 }} /> US
              Dollars
            </MenuItem>
          </Select>
        </FormControl>
        {/* <TextField placeholder="Placeholder" fullWidth select value={portfolio.currencyType ? portfolio.currencyType : ''} onChange={(e, v) => {
                actions.setPortfolioValue(props, portfolio.portfolioNumber, "currencyType", e.target.value);
            }}>
                <MenuItem value={'CAD'}>CAD</MenuItem>
                <MenuItem value={'USD'}>USD</MenuItem>
            </TextField> */}
      </div>

      {portfolio.currencyType && (
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              color: "#797878",
              marginTop: 50,
            }}
          >
            Analysis Pre-Check
          </div>
          <PreCheck.Render {...props} />
        </div>
      )}
    </div>
  );
};

function isComplete(props) {
  return PreCheck.isComplete(props);
}

export { Render, isComplete };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/BeforeYouStart.js